import { TextField } from "@mui/material";
import { memo } from "react";

import type { FloatingTextFieldProps } from "./FloatingTextField.types";
import * as styles from "./FloatingTextField.styles";

export type { FloatingTextFieldProps } from "./FloatingTextField.types";

export const FloatingTextField = memo(function FloatingTextField({
  label,
  fieldState = "default",
  helperText,
  error,
  slotProps,
  ...textFieldProps
}: FloatingTextFieldProps) {
  const isError = fieldState === "error" || Boolean(error);
  const isSuccess = fieldState === "success";

  return (
    <TextField
      label={label}
      variant="outlined"
      fullWidth
      error={isError}
      helperText={helperText}
      sx={styles.wrapper}
      slotProps={{
        ...slotProps,
        input: {
          ...slotProps?.input,
          className: isSuccess ? "sefano-success" : undefined,
        },
      }}
      {...textFieldProps}
    />
  );
});
